module.exports = __webpack_public_path__ + "img/FixedTime.2a9a19fd.svg";